import { Injectable } from '@angular/core';
import { VisitorRegistrationFormStatus } from '../models/visitor-registration-form-status';
import { Observable, of } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { Gender } from '../models/gender';
import { BusinessVisaTypeEnum } from '../models/business-visa-type.enum';

@Injectable({
  providedIn: 'root'
})
export class EnumTranslationService {
  
  constructor(private translateService: TranslateService) {
  }

  getGenderOptions(): Observable<any[]> {
    const data: any[] = [
      { id: Gender.Male, value: this.translateService.instant(Gender.Male) },
      { id: Gender.Female, value: this.translateService.instant(Gender.Female) },
    ];

    return of(data);
  }

  getBusinessVisaOptions(): Observable<any[]> {
    const data: any[] = [
      { id: BusinessVisaTypeEnum.EuropeanPassport, value: this.translateService.instant(BusinessVisaTypeEnum.EuropeanPassport) },
      { id: BusinessVisaTypeEnum.OtherPassport, value: this.translateService.instant(BusinessVisaTypeEnum.OtherPassport) },
      { id: BusinessVisaTypeEnum.BusinessVisa, value: this.translateService.instant(BusinessVisaTypeEnum.BusinessVisa) },
      { id: BusinessVisaTypeEnum.OtherEuBusinessVisa, value: this.translateService.instant(BusinessVisaTypeEnum.OtherEuBusinessVisa) },
      { id: BusinessVisaTypeEnum.OtherEuCountryWorkVisa, value: this.translateService.instant(BusinessVisaTypeEnum.OtherEuCountryWorkVisa) },
    ]

    return of(data);
  }

  getRegistrationFormStatusOptions(): Observable<any[]> {
    const data: any[] = [
      { id: VisitorRegistrationFormStatus.New, value: this.translateService.instant(VisitorRegistrationFormStatus.New) },
      { id: VisitorRegistrationFormStatus.Draft, value: this.translateService.instant(VisitorRegistrationFormStatus.Draft) },
      { id: VisitorRegistrationFormStatus.Submitted, value: this.translateService.instant(VisitorRegistrationFormStatus.Submitted) },
      { id: VisitorRegistrationFormStatus.InReview, value: this.translateService.instant(VisitorRegistrationFormStatus.InReview) },
      { id: VisitorRegistrationFormStatus.Approved, value: this.translateService.instant(VisitorRegistrationFormStatus.Approved) },
      { id: VisitorRegistrationFormStatus.Rejected, value: this.translateService.instant(VisitorRegistrationFormStatus.Rejected) },
      { id: VisitorRegistrationFormStatus.Archived, value: this.translateService.instant(VisitorRegistrationFormStatus.Archived) },
      { id: VisitorRegistrationFormStatus.HRApproved, value: this.translateService.instant(VisitorRegistrationFormStatus.HRApproved) },
      { id: VisitorRegistrationFormStatus.EHSApproved, value: this.translateService.instant(VisitorRegistrationFormStatus.EHSApproved) },
      { id: VisitorRegistrationFormStatus.ApprovedForReview, value: this.translateService.instant(VisitorRegistrationFormStatus.ApprovedForReview) },
      { id: VisitorRegistrationFormStatus.HRApprovedForReview, value: this.translateService.instant(VisitorRegistrationFormStatus.HRApprovedForReview) },
      { id: VisitorRegistrationFormStatus.EHSApprovedForReview, value: this.translateService.instant(VisitorRegistrationFormStatus.EHSApprovedForReview) },
    ];

    return of(data);
  }
}
